import requestAxios from "@/helpers/request_axios";
import * as MutationsType from "./mutationsType";

export default {
  async getFormSchemaConfig({ commit }, { id }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/form-schemas/${id}`,
        method: "GET",
      });

      commit(MutationsType.SET_FORM_SCHEMA, response.data.data);
      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
};
